import { render } from "./SimpleLayouts.vue?vue&type=template&id=50771134"
import script from "./SimpleLayouts.vue?vue&type=script&lang=js"
export * from "./SimpleLayouts.vue?vue&type=script&lang=js"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__